import { render, staticRenderFns } from "./home_download.vue?vue&type=template&id=02ba309f&scoped=true&"
import script from "./home_download.vue?vue&type=script&lang=js&"
export * from "./home_download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ba309f",
  null
  
)

export default component.exports